module.exports = __webpack_public_path__ + "static/img/document.dde5f0ea.png";